import React from "react";
import MasterLayout from "../masterLayout/MasterLayout";
import Breadcrumb from "../components/Breadcrumb";
import PhoneNumberLayer from "../components/PhoneNumberLayer";

const PhoneNumberPages = () => {
    return (
        <>
            {/* MasterLayout */}
            <MasterLayout>
                {/* BreadCrumb */}
                <Breadcrumb title='Phone number'/>

                {/* Phone Number Layer*/}
                <PhoneNumberLayer/>

            </MasterLayout>
        </>
    )
}

export default PhoneNumberPages;